class CyberSourceCardPaymentHelper {
    constructor() {
        this.enabled = false;
        this.paymentIsLocked = false;
        this.hasRegisteredCard = null;
        this.returnUrl = null;
        this.isEmbedded = null;  //indicate if iFrame in use
        this.paymentFormId = null; //local form to setup and post - not required if using onRequestFieldsFetched
        this.requestFieldsUrl = null; //web method that takes productData, returnUrl and isEmbedded parameters
        this.iFrameElementId = "fourd_payment_frame";
        this.iFrameContentUrl = "/IFrameAccount/PaymentForm/";
        this.registeredCardRequired = true;
    }
    onCreditCardPaymentButtonClicked() {
        if (!this.enabled) return;

        if (!this.paymentIsLocked) {

            const productData = this.onProductDataRequested();
            if (!productData) {
                this.onError("Product data missing", "CyberSourceCardPaymentHelper/onCreditCardPaymentButtonClicked", false, true);
                return;
            }

            if (this.registeredCardRequired && this.hasRegisteredCard === false) {
                //we don't have  a registered card, delegate the product data
                this.onPaymentButtonClickedNoRegisteredCard(productData);
                return;
            }

            //if (!this.returnUrl) this.returnUrl = $("#FourD_Data_ReturnUrl").val();

            this.paymentIsLocked = true;
            this.onPaymentExecuting(); //button could show 'Requesting ...'
            let helperInstance = this;

            $.ajax({
                data: JSON.stringify({
                    productId: productData?.productId,
                    offerId: productData?.offerId,
                    transactionAmount: productData?.amountToPay,
                    returnUrl: helperInstance.returnUrl,
                    isEmbedded: helperInstance.isEmbedded
                }),
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: helperInstance.requestFieldsUrl,
                dataType: "json",
                timeout: 60000,
                success: function (response, textStatus, jqXHR) {
                    if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                        fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                    }

                    var returnObject = response;
                    if (response && response.d) returnObject = response.d;

                    if (returnObject) {
                        //RequestFields is an object
                        if (returnObject.ServiceOperationOutcome === 10 && returnObject.RequestFields) {
                            if (typeof (helperInstance.onRequestFieldsFetched) == "function") {
                                helperInstance.onRequestFieldsFetched(returnObject, productData);
                            }
                            else {
                                if (helperInstance.isEmbedded) {
                                    helperInstance.submitRequestFieldsResponseIFrame(returnObject, helperInstance.iFrameElementId, helperInstance.iFrameContentUrl);
                                }
                                else {
                                    helperInstance.submitRequestFieldsResponseCurrentDocument(returnObject, helperInstance.paymentFormId);
                                }
                            }
                        }
                        else if (
                            (returnObject.ServiceOperationOutcome === 40 && returnObject.ProductOfferValidationOutcome === 5) //offer no longer valid - maybe redeemed
                            || (returnObject.ServiceOperationOutcome === 50) //not allowed
                        ) {
                            helperInstance.onError(helperInstance.requestFieldsUrl + ' outcome was non success', helperInstance.requestFieldsUrl, true);
                        }
                        else {
                            helperInstance.onError(helperInstance.requestFieldsUrl + ' outcome was non success', helperInstance.requestFieldsUrl, true);
                        }
                    }

                    helperInstance.paymentIsLocked = false;
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    helperInstance.paymentIsLocked = false;
                    helperInstance.onError(errorThrown, helperInstance.requestFieldsUrl, true);

                    if (typeof (fourdHandleAjaxError) != 'undefined') {
                        fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                    }

                }
            });

        }
    }
    submitRequestFieldsResponseCurrentDocument(responseObject, paymentFormId) {
        for (var key in responseObject.RequestFields) {
            this.updateOrAppendControlValue(key, responseObject.RequestFields[key], paymentFormId);
        }

        this.postSopForm(responseObject.CyberSourceUrl, paymentFormId);
    }
    submitRequestFieldsResponseIFrame(responseObject, childIdentifier, contentUrl) {
        if (IFrameMessaging) {
            IFrameMessaging.ResetFrame({});
            let helperInstance = this;
            if (!IFrameMessaging.RegisterChild({
                childIdentifier: childIdentifier,
                contentUrl: contentUrl,
                onMessage: function (messageData) {
                    if (messageData.action == IFrameMessagingAction.CyberSourcePayment && messageData.type == IFrameMessagingType.Ack) { //payment events
                        if (!(messageData.payload && messageData.payload.taskAccepted)) {
                            //TODO: could fallback to local form
                            helperInstance.onError("CyberSourcePayment task could not be delegated", "IFrameMessaging/onMessage", true);
                        }
                    }

                    if (messageData.action == IFrameMessagingAction.FrameInteractionDone) { //dismiss/continue selected on iFrame
                        helperInstance.completePayment(messageData.payload);
                    }

                    return null;
                },
                onError: function (err, stageText) {
                    if (typeof (fourdLogErrorOrWarning) != 'undefined') {
                        fourdLogErrorOrWarning(`Error '${err}' at stage '${stageText}'`, err);
                    }
                },
                onCompletion: function (isFrameLinkOk) {
                    if (isFrameLinkOk) {
                        IFrameMessaging.QueueMessage({
                            type: IFrameMessagingType.Request,
                            action: IFrameMessagingAction.CyberSourcePayment,
                            payload: {
                                //productId: productData?.productId,
                                //offerId: productData?.offerId,
                                //amountToPay: productData?.amountToPay,
                                requestFieldsResponse: responseObject,
                                isEmbedded: true
                            }
                        });
                    }
                    else {
                        //TODO: could fallback to local form
                        helperInstance.onError("IFrame link could not be established", "IFrameMessaging/onCompletion", true);
                    }
                },
                completionTimeoutMillis: 30000
            })) {
                //TODO: could fallback to local form
                this.onError("IFrame setup failed", "IFrameMessaging/RegisterChild", true);
            }
        }
        else {
            this.onError("IFrameMessaging not defined", "IFrameMessaging", true);
        }
    }
    updateOrAppendControlValue(controlId, value, paymentFormId) {
        var controlQ = $("#" + controlId);
        if (controlQ.length === 0) {
            $("#" + paymentFormId).append('<input type="hidden" id = "' + controlId + '" name="' + controlId + '" value="' + value + '" />');
        }
        else {
            controlQ[0].value = value;
        }
    }
    copyControlValue(controlIdToSet, controlIdToRead) {
        var controlToSet = $("#" + controlIdToSet)[0];
        if (controlToSet) {
            var controlToRead = $("#" + controlIdToRead)[0];
            if (controlToRead) {
                controlToSet.value = controlToRead.value;
            }
        }
    }
    copyExpiryDateControlValue(controlIdToSet, controlIdToReadMonth, controlIdToReadYear) {
        var controlToSet = $("#" + controlIdToSet)[0];
        if (controlToSet) {
            var controlToReadMonth = $("#" + controlIdToReadMonth)[0];
            var controlToReadYear = $("#" + controlIdToReadYear)[0];
            if (controlToReadMonth && controlToReadYear) {
                controlToSet.value = controlToReadMonth.value + "-" + controlToReadYear.value;
            }
        }
    }
    validateCreditCardNumber(controlIdToSet, controlIdToRead) {
        var result = fourdHelper?.cardValidator?.number($("#" + controlIdToRead).val());
        switch (result?.card?.type) {
            case "visa":
                $("#" + controlIdToSet).val("001");
                $("#" + controlIdToRead).addClass(result?.card?.type);
                break;
            case "mastercard":
                $("#" + controlIdToSet).val("002");
                $("#" + controlIdToRead).addClass(result?.card?.type);
                break;
            case "maestro":
                $("#" + controlIdToSet).val("042");
                $("#" + controlIdToRead).addClass(result?.card?.type);
                break;
            default:
                $("#" + controlIdToSet).val("");
                $("#" + controlIdToRead).removeClass(["visa", "mastercard", "maestro"]).addClass("cardnumber");
                break;
        }
    }
    addControlValueToRequestFields(requestFields, requestFieldsKey, controlIdToRead) {
        if (requestFields) {
            var controlToRead = $("#" + controlIdToRead)[0];
            if (controlToRead) {
                requestFields[requestFieldsKey] = controlToRead.value;
            }
        }
    }
    addExpiryDateControlValueToRequestFields(requestFields, requestFieldsKey, controlIdToReadMonth, controlIdToReadYear) {
        if (requestFields) {
            var controlToReadMonth = $("#" + controlIdToReadMonth)[0];
            var controlToReadYear = $("#" + controlIdToReadYear)[0];
            if (controlToReadMonth && controlToReadYear) {
                requestFields[requestFieldsKey] = controlToReadMonth.value + "-" + controlToReadYear.value;
            }
        }
    }
    postSopForm(cyberSourceSubmitUrl, paymentFormId) {
        if (cyberSourceSubmitUrl) {
            var form = $("#" + paymentFormId);
            form.attr("action", cyberSourceSubmitUrl);
            form.submit();
        }
        else {
            this.paymentIsLocked = false;
            this.onError('cyberSourceSubmitUrl parameter was not supplied', 'CyberSourceCardPaymentHelper/postSopForm', true);
        }
    }
    completePayment(cyberSourceProcessedResponse) { //if iFrame child returned back outcome
        this.paymentIsLocked = false;

        if (!cyberSourceProcessedResponse) {
            this.onError('No response payload received', 'CyberSourceCardPaymentHelper/completePayment', true);
            return;
        }

        if (cyberSourceProcessedResponse && cyberSourceProcessedResponse.ServiceOperationOutcome === 10) {

            this.onPaymentExecuted(cyberSourceProcessedResponse.TransactionAccepted == true, cyberSourceProcessedResponse);
        }
        else {
            this.onError('non success response', 'CyberSourceCardPaymentHelper/completePayment', true);
        }
    }
    //onCreditCardPaymentLoaded: function () { },
    initialise(options) {
        var result = false;
        
        try {
            if (!options) options = {};
            if (!options.config) options.config = {};
            if (!options.callbacks) options.callbacks = {};
            if (typeof (FourDConfiguration) !== 'undefined' && FourDConfiguration.endpoints) {
                if (!options.config.requestFieldsUrl && typeof (FourDConfiguration.endpoints.cybersourceCardRequestSubscriptionAuthorisationFields) == 'string') options.config.requestFieldsUrl = FourDConfiguration.endpoints.cybersourceCardRequestSubscriptionAuthorisationFields;
            }
            if (!options.config.paymentFormId && !options.callbacks.onRequestFieldsFetched && $('#paymentForm').length > 0) options.config.paymentFormId = 'paymentForm';
            if (!options.config.returnUrl) options.config.returnUrl = $("#FourD_Data_ReturnUrl").val() ?? location.href;
            if (typeof (options.config.registeredCardRequired) !== 'undefined' && FourDConfiguration.endpoints) {
                this.registeredCardRequired = options.config.registeredCardRequired;
            }

            if (options.config
                && options.config.requestFieldsUrl) {

                this.requestFieldsUrl = options.config.requestFieldsUrl;
                if (options.config.hasRegisteredCard == true || options.config.hasRegisteredCard == false) this.hasRegisteredCard = options.config.hasRegisteredCard;
                if (options.config.returnUrl) this.returnUrl = options.config.returnUrl;
                if (options.config.isEmbedded == true || options.config.isEmbedded == false) this.isEmbedded = options.config.isEmbedded;
                if (options.config.paymentFormId) this.paymentFormId = options.config.paymentFormId;

                if (options.callbacks
                    && options.callbacks.onProductDataRequested
                    && (options.callbacks.onRequestFieldsFetched || options.config.paymentFormId || (this.isEmbedded && this.iFrameElementId && this.iFrameContentUrl)) //either required
                ) {
                    if (typeof (options.callbacks.onProductDataRequested) == 'function') this.onProductDataRequested = options.callbacks.onProductDataRequested;
                    if (typeof (options.callbacks.onIsReadyToPayResult) == 'function') this.onIsReadyToPayResult = options.callbacks.onIsReadyToPayResult;
                    if (typeof (options.callbacks.onError) == 'function') this.onError = options.callbacks.onError;
                    if (typeof (options.callbacks.onRequestFieldsFetched) == 'function') this.onRequestFieldsFetched = options.callbacks.onRequestFieldsFetched;
                    if (typeof (options.callbacks.onPaymentButtonClickedNoRegisteredCard) == 'function') this.onPaymentButtonClickedNoRegisteredCard = options.callbacks.onPaymentButtonClickedNoRegisteredCard;
                    if (typeof (options.callbacks.onPaymentExecuting) == 'function') this.onPaymentExecuting = options.callbacks.onPaymentExecuting;
                    if (typeof (options.callbacks.onPaymentCancelled) == 'function') this.onPaymentCancelled = options.callbacks.onPaymentCancelled;
                    if (typeof (options.callbacks.onPaymentExecuted) == 'function') this.onPaymentExecuted = options.callbacks.onPaymentExecuted;

                    result = true;
                    this.enabled = true;

                    //this.onCreditCardPaymentLoaded();
                }
            }
        }
        catch (err) {
            this.onError(err, 'CyberSourceCardPaymentHelper/initialise');
        }
        return result;

    }
    onProductDataRequested() { return null; }
    onIsReadyToPayResult(isAccepted) { }
    onError(err, stageText, wasPaymentExecuting, wasProductMissing) { }
    //onRequestFieldsFetched: function (responseObject, productData) { }, //if not supplied then paymentFormId should be
    onPaymentButtonClickedNoRegisteredCard(productData) { }
    onPaymentExecuting() { }
    onPaymentCancelled(event) { }
    onPaymentExecuted(isAccepted, responseData) { }
};

const CyberSourceCardPayment = new CyberSourceCardPaymentHelper();